import { createSlice } from "@reduxjs/toolkit"

const slice = createSlice({
    name: "switcher",
    initialState: {
        showSettings: true,
        sidebarLogo: true,
        fixedHeader: true,
        sidebarCollapsed: false,
        settingPanelVisible: false,
    },
    reducers: {
        toggleSiderBar: (state) => {
            state.sidebarCollapsed = !state.sidebarCollapsed
        },
        toggleSettingPanel: (state) => {
            state.settingPanelVisible = !state.settingPanelVisible
        },
        changeSetting: (state, action) => {
            const {key ,value } = action.payload;
            state[key] = value;
        },
        setSidebarLogo: (state, action) => {
            state.sidebarLogo = action.payload
        },
    },
})

export const { setSidebarLogo, toggleSiderBar, toggleSettingPanel, changeSetting } = slice.actions
export const switcher =  slice.reducer